export const QRid: React.FC<{
  id: string;
}> = ({ id }) => {
  return <div className="rounded bg-gray-100 px-2 text-xl text-accept-dark-blue ring-1 ring-gray-400">{id}</div>;
};
